<template>
    <div  class="container">
        <div v-if="!isLoading" class="columns">
            <div  class="column is-3 left-column">
                <div class="notification">
                    <p class="heading" style="font-family: sans-serif;font-weight: 600">
                        {{selectedFlightKey}}</p>
                </div>
                <aside class="menu">
                    <div v-for="menuGroup in menuGroups" :key="menuGroup.label">
                        <ul class=" main-menu-list main-menu-list-is-active">
<!--                            :class="{'main-menu-list-is-active':selectedMenu==menuGroup.label}">-->
                            <li class="" >
<!--                                    v-if="menuGroup.label && menuGroup.label.length"-->
                                <a>
<!--                                    @click="setSelectedAcordion(menuGroup.label)"-->
                                    <div class="level">
<!--                                        <div class="level-left">-->
<!--                                            <font-awesome-icon-->
<!--                                                    :icon="selectedMenu == menuGroup.label ? 'angle-up' : 'angle-right' "-->
<!--                                                    size="2x"/>-->
<!--                                        </div>-->
                                        <div class="level-right main-menu-list-label">
                                            {{ menuGroup.label }}
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>

                        <ul class="menu-list animate__animated animate__zoomIn animate__faster">
<!--                            v-if="selectedMenu==menuGroup.label">-->
                            <li class="menu-list-item" v-for="menuItem in menuGroup.items"
                                :key="menuItem.component">
<!--                                <a :class="{ 'is-active': selectedComponent === menuItem.component || menuItem.component === selectedComponentAltMainMenu }"-->
                                <a :class="{ 'is-active': selectedComponent === menuItem.component || menuItem.component === selectedComponentAltMainMenu }"
                                        @click="setSelectedComponent(menuItem.component)">
                                    <font-awesome-icon :icon="menuItem.icon" size="lg" color="#727c8f"
                                                       class="menu-icon"></font-awesome-icon>
                                    {{ menuItem.label}}
                                </a>
                                <div class="alt-menu-list" v-for="altMenu in altMenuGroups"
                                     :key="altMenu.menuGroupComponent">
                                    <ul v-if="menuItem.component.includes(altMenu.menuGroupComponent)" class="is-active">
<!--                                        :class="{'is-hidden' : !selectedComponentAltMenu.includes(altMenu.menuGroupComponent)}"-->

                                        <li class="alt-menu-list-item" v-for="altMenuItem in altMenu.items"
                                            :key="altMenuItem.component">
                                            <a @click="setSelectedComponent(altMenuItem.component,altMenu.menuGroupComponent)" :class="{ 'is-active': selectedComponent === altMenuItem.component}">
                                               {{"- "+altMenuItem.label}}
<!--                                               :class="{ 'is-active': selectedComponent === altMenuItem.component}">{{altMenuItem.label}}-->
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </aside>
            </div>


            <div class="column is-10 right-column">
                <keep-alive>
                    <component class="animate__animated animate__slideInLeft animate__faster"
                               :is="selectedComponent"
                               :id="selectedFlightKey" :flight="selectedFlight" :additionalCrew = "additionalCrew"/>
                </keep-alive>
            </div>
        </div>
        <div v-else>
            <loading-button/>
        </div>
    </div>

</template>

<script>
    import OverView from "./Flight/OverView";
    import Notams from "./BeforeTake-off/Notams/Notams";

    import PreFlightReporting from "./BeforeTake-off/PreFlightReporting";
    import ViewandSign from "./BeforeTake-off/ViewandSign";
    import PaxInformation from "./BeforeTake-off/PaxInformation";
    import AtısDep from "./BeforeTake-off/BT-ACN/BT-AtısDep";
    import ClearanceDep from "./BeforeTake-off/BT-ACN/BT-ClearanceDep";
    import Notes from "./BeforeTake-off/BT-ACN/BT-Notes";
    import FuelTimeCheck from "./InFlight/FuelTimeCheck";
    import OffBlock from "./InFlight/OffBlock";
    import RVSMCheck from "./InFlight/RVSMCheck";

    import FlightPlaning from "./BeforeTake-off/FlightPlaning/FlightPlaning";
    import NOAA from "./BeforeTake-off/FlightPlaning/NOAA";
    import NOTAMs from "./BeforeTake-off/FlightPlaning/NOTAMs";
    import ShortATC from "./BeforeTake-off/FlightPlaning/ShortATC";
    import WeatherCharts from "./BeforeTake-off/FlightPlaning/WeatherCharts";
    import WX from "./BeforeTake-off/FlightPlaning/WX";
    import AdditionalDocuments from "./BeforeTake-off/FlightPlaning/AdditionalDocuments";

    import DEP from "./BeforeTake-off/Notams/DEP";
    import DEST from "./BeforeTake-off/Notams/DEST";
    import DEPALT from "./BeforeTake-off/Notams/DEPALT";
    import DESTALT from "./BeforeTake-off/Notams/DESTALT";
    import DESTALT2 from "./BeforeTake-off/Notams/DESTALT2";
    import ENROUTEALT from "./BeforeTake-off/Notams/ENROUTEALT";
    import SelectedNotams from "./BeforeTake-off/Notams/SelectedNotams";

    import IFAtısDep from "./InFlight/IN-ACN/IF-AtısDest";
    import IFClearanceDep from "./InFlight/IN-ACN/IF-ClearanceDep";

    import IFNotes from "./InFlight/IN-ACN/IF-Notes";
    import IFAtısAlt from "./InFlight/IN-ACN/IF-AtısAlt";

    import PostFlightReporting from "./AterLanding/PostFlightReporting";
    import PostValidateAndSign from "./AterLanding/PostValidateAndSign";
    import {mapState, mapActions} from "vuex";
    import EditFlightService from "../../services/editFlight.service";
    import ScheduleService from "../../services/schedule.service";
    import {loadingMixin} from "../../utils/mixins";
    import LoadingButton from "../../components/ui/LoadingButton";

    export default
    {
        name: "IpadMain",
        mixins: [loadingMixin],
        data() {
            return {
                selectedComponent: 'OverView',
                selectedFlightKey: this.$route.params.id,
                selectedFlight: this.$route.params.flight,
                selectedKeyforNetline : this.$route.params.kfnl,
                selectedLegNo : this.$route.params.legno,
                additionalCrew: "",
                selectedComponentAltMenu: ["OverView"],
                selectedComponentAltMainMenu: '',
                selectedMenu: "",
                menuGroups: [
                    {
                        label: "Flight",
                        items: [{label: "Overview", component: "OverView", icon: "plane-departure"},]
                    },
                    {
                        label: "Before Take-Off",
                        items: [
                            {label: "Flight Planning", component: "FlightPlaning", icon: "map"},
                            {label: "WX & NOTAMs", component: "DEP", icon: "caret-square-up"},
                            {label: "Pre Flight Reporting", component: "PreFlightReporting", icon: "file-alt"},
                            {label: "ATIS/Clearance/Notes", component: "Notes", icon: "hand-point-up"},
                            {label: "Pax Information", component: "PaxInformation", icon: "file"},
                            {label: "Validate and Sign", component: "ViewandSign", icon: "file-signature"},
                               ]
                    },
                    {
                        label: "In Flight",
                        items: [
                            {label: "OFF Block", component: "OffBlock", icon: "clock"},
                            {label: "RVSM Check", component: "RVSMCheck", icon: "user"},
                            {label: "Fuel & Time Check", component: "FuelTimeCheck", icon: "plane"},
                            {label: "ATIS/Clearance/Notes", component: "IFAtısDep", icon: "hand-point-up"},
                        ]
                    },
                    {
                        label: "After Landing",
                        items: [
                            {label: "Post Flight Reporting", component: "PostFlightReporting", icon: "folder"},
                            {label: "Validate And Sign", component: "PostValidateAndSign", icon: "file-signature"},
                        ]
                    }
                ],
                altMenuGroups: [
                    {
                        menuGroupComponent: "FlightPlaning",
                        items: [
                            {label: "OFP", component: "FlightPlaning", mainComponent: 'FlightPlaning'},
                            {label: "WX", component: "WX", mainComponent: 'FlightPlaning'},
                            {label: "NOTAMs", component: "NOTAMs", mainComponent: 'FlightPlaning'},
                            {label: "Short ATC", component: "ShortATC", mainComponent: 'FlightPlaning'},
                            {label: "Weather Charts", component: "WeatherCharts", mainComponent: 'FlightPlaning'},
                            {
                                label: "Additional Documents",
                                component: "AdditionalDocuments",
                                mainComponent: 'FlightPlaning'
                            },
                        ]
                    },
                    {
                        menuGroupComponent: "DEP",
                        items:
                        [
                            {label: "DEP", component: "DEP", mainComponent: 'DEP'},
                            {label: "DEST", component: "DEST", mainComponent: 'DEP'},
                            {label: "DEST ALT", component: "DESTALT", mainComponent: 'DEP'},
                            {label: "DEST ALT2", component: "DESTALT2", mainComponent: 'DEP'},
                            {label: "DEP ALT", component: "DEPALT", mainComponent: 'DEP'},
                            {label: "Enroute ALT", component: "ENROUTEALT", mainComponent: 'DEP'},
                            {label: "Selected Notams", component: "SelectedNotams", mainComponent: 'DEP'},
                        ]
                    },
                    {
                        menuGroupComponent: "Notes",
                        items: [
                            {label: "ATIS Dep", component: "AtısDep", mainComponent: 'PreFlightReporting'},
                            {label: "Clearance", component: "ClearanceDep", mainComponent: 'PreFlightReporting'},
                            //{label: "Clearance", component: "ClearanceDep", mainComponent: 'PreFlightReporting'}, kaldırıldı. üst satır ile aynısı idi yoruma alındı.
                            // {label: "Clearance Text", component: "ClearanceDest", mainComponent: 'PreFlightReporting'},
                            {label: "Notes", component: "Notes", mainComponent: 'PreFlightReporting'},
                        ]
                    },
                    {
                        menuGroupComponent: "IFAtısDep",
                        items: [
                            {label: "ATIS Dest", component: "IFAtısDep", mainComponent: 'IFAtısDep'},
                            {label: "Alt", component: "IFAtısAlt", mainComponent: 'IFAtısDep'},
                            {label: "Clearance", component: "IFClearanceDep", mainComponent: 'IFAtısDep'},
                            // {label: "Clearance Text", component: "IFClearanceDest", mainComponent: 'IFAtısDep'},
                            {label: "Notes", component: "IFNotes", mainComponent: 'IFAtısDep'},
                        ]
                    },
                ]
            }
        },

        components: {
            LoadingButton,
            OverView,
            FlightPlaning,
            WX,
            NOAA,
            NOTAMs,
            ShortATC,
            WeatherCharts,
            AdditionalDocuments,
            Notams,
            PreFlightReporting,
            PaxInformation,
            ViewandSign,
            AtısDep,
            ClearanceDep,
            Notes,
            FuelTimeCheck,
            OffBlock,
            RVSMCheck,
            DEP,
            DEST,
            DEPALT,
            DESTALT,
            DESTALT2,
            ENROUTEALT,
            SelectedNotams,
            PostFlightReporting,
            PostValidateAndSign,
            IFAtısDep,
            IFClearanceDep,
            IFNotes,
            IFAtısAlt
        },

        async created()
        {

            this.isLoading = true;

            var dater = new Date();

            var datenow = dater.getFullYear() + ("0" + (dater.getMonth() + 1)).slice(-2) + ("0" + dater.getDate()).slice(-2) + ("0" + dater.getHours() ).slice(-2) + ("0" + dater.getMinutes()).slice(-2) + ("0" + dater.getSeconds()).slice(-2);

            console.log(datenow);
            // başlangıçta gerekli olan route üzerinde bunlar olacak birde kfnl iste olsun bitsin gitsin.  KFZ, KFNL,

            var keylist = this.selectedFlightKey.split("_");
            var date = keylist[2];
            date = date.substring(0,4)+"-"+date.substring(4,6)+"-"+date.substring(6,8)+"T00:00:00";

            await this.getFlightbyid(this.selectedFlightKey, date); //this.selectedFlight.std // bunu legno ya çevirebiliriz. aslında ? ...
            this.$route.params.flight = this.selectedFlight
            this.$route.params.kfnl =  this.selectedFlight.kfnl

            if (!this.selectedFlight || !this.selectedFlightKey)
            {
                this.$router.push({name: 'Schedule'});
            }

            this.ClearInputsObject();
            // ouputs ...

            this.GetNotamImportantWList(); //await

            this.GetLastAttachmentJson({LastKeyForNetline:this.selectedFlight.fKeyForNetline, STD:this.selectedFlight.std}); //await

            await this.GetLastOCCSelfVersions_VS_IPADLastKnownVersions({KFZ:this.selectedFlight.fKeyForZip}); //await

            try
            {
                await this.GetCombinedAllJson({KFZ:this.selectedFlight.fKeyForZip,STD:this.selectedFlight.std,JLVT:this.OCCSelfVersions_VS_IPADLastKnownVersions[this.OCCVers_IPADVers_LastIndex].jlvt,WLVT:this.OCCSelfVersions_VS_IPADLastKnownVersions[this.OCCVers_IPADVers_LastIndex].wlvt,DeviceUID:this.OCCSelfVersions_VS_IPADLastKnownVersions[this.OCCVers_IPADVers_LastIndex].devicE_UUID});
            } catch (e)
            {
                this.$notify({title: "Warning", text:" Some json data of this flight couldn't get you can check data transfer status section "+e.message, type: "warning"});
            }


            // try
            // {
            //    await this.GetCombinedAllJson({KFZ:this.selectedFlight.fKeyForZip,STD:this.selectedFlight.std,JLVT:this.OCCSelfVersions_VS_IPADLastKnownVersions[this.OCCVers_IPADVers_LastIndex].jlvt,WLVT:this.OCCSelfVersions_VS_IPADLastKnownVersions[this.OCCVers_IPADVers_LastIndex].wlvt});
            // } catch (e)
            // {
            //     this.$notify({title: "Warning", text:" Some json data of this flight couldn't get you can check data transfer status section "+e.message, type: "warning"});
            // }

            var parsedObject = this.inputsToObject(this.RawInputs);

            await this.SetinputsToObject({data:parsedObject});
            //await this.GetLastFilesJson({KFZ:this.selectedFlight.fKeyForZip, STD:this.selectedFlight.std});
            this.additionalCrew = (this.InputsObject.BTO.additionalCrew === undefined || this.InputsObject.BTO.additionalCrew === null) ? " " : this.InputsObject.BTO.additionalCrew;
            date = new Date();

            var datenow2 = date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2) + ("0" + date.getHours() ).slice(-2) + ("0" + date.getMinutes()).slice(-2) + ("0" + date.getSeconds()).slice(-2);
            console.log(datenow2);

            this.isLoading = false;
        },

        computed: {

            ...mapState("ipadmain",["FKey1", "selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","OCCVers_IPADVers_LastIndex","LastInputsJson","InputsObject","InputFiles","CombinedJson","RawInputs","NotamImportantList"]),

        },

        methods: {

            ...mapActions("ipadmain", ["GetLastJrJson", "GetLastWrJson", "GetLastAttachmentJson", "GetLastOCCSelfVersions_VS_IPADLastKnownVersions", "GetLastInputsJson","SetinputsToObject","ClearInputsObject","GetLastFilesJson","GetCombinedAllJson","GetNotamImportantWList"]),




            async getFlightbyid(id,std) {
                try {

                        //var flightList = await EditFlightService.getSelectedFlightByKeyForZip(id,std);
                        var flightList = await EditFlightService.getSelectedFlightByLegNo(std,this.selectedLegNo)
                        this.selectedFlight = flightList;
                        this.selectedFlight.fno = this.selectedFlight.fno + this.selectedFlight.suffix;
                        return flightList;

                } catch (e) {
                    this.$notify({title: "Error",  text: "Error on getSelectedFlightByKeyForZip function" + e.message, type: "error"});
                }
            },

            async getNotamImportantWordList()
            {
                var wordlist= await ScheduleService.GetNotamImportantList();
                this.NotamImportantList = wordlist;
            },

            setSelectedComponent(value, main) {
                this.selectedComponent = value;
                this.selectedComponentAltMainMenu = main;
                if (this.selectedComponentAltMenu.includes(value))
                {
                    this.selectedComponentAltMenu.pop(value);
                } else {
                    this.selectedComponentAltMenu.push(value);
                }
            },

            setSelectedAcordion(value) {

                    console.log(value);
                    const b = this.menuGroups
                    this.selectedComponent = b[0].items[0].component

            },

            inputsToObject(data) {
                let retObj = {BTO: {}, IF: {}, AL: {}};
                if(data != null) {
                    data.forEach(i => {
                        var arrMatch = i.field.match(/^(?<arrName>\w+)\[(?<index>\d+)\]\.(?<prop>\w+)$/i);
                        if (arrMatch && arrMatch.length === 4) {
                            var {arrName, index, prop} = arrMatch.groups;
                            if (!retObj[i.page].hasOwnProperty(arrName)) retObj[i.page][arrName] = [];
                            if (!retObj[i.page][arrName][index]) retObj[i.page][arrName][index] = {};
                            retObj[i.page][arrName][index][prop] = i.value;
                        } else {
                            retObj[i.page][i.field] = i.value;
                        }
                    });
                }
                return retObj;
            }

        }
    }
</script>

<style scoped>
    .notification {
        height: 80px;
    }

    .menu-icon {
        margin-right: 10px;
    }

    .alt-menu-list {
        margin-left: 15px;
    }

    .left-column {
        /*background-color: rgba(0, 0, 0, 0.71);*/
        height: 920px;
        position: relative;
        /*font-style: italic;*/
        overflow-y: scroll;
        box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
    }

    .right-column {
        height: 920px;
        background-color: rgba(0, 0, 0, 0);
        overflow-y: scroll;
    }

    .menu-list a {
        font-style: normal;
        font-family: sans-serif;
        font-size: 17px;
        /*font-weight: 600;*/
        /*font-variant: all-small-caps*/
        margin: 5px 15px;
        opacity: .86;
        border-radius: 4px;
        display: block;
        padding: 1px 15px;
    }

    .menu-list li:hover {
        transition: all .3s ease-in-out;
    }

    .alt-menu-list-item :hover {
        transition: all .3s ease-in-out;
    }

    .alt-menu-list a {
        font-size: 20px;
    }

    .menu-list a.is-active {
        position: relative;
        background-color: #888888;              /*old color #0073aa;*/
        /*background-color: #5a5a5c;*/
        color: #fff;
        height: 100%;
        margin-left: -15px;
        margin-right: -15px;
        transition: all .3s ease-in-out;
    }

    .main-menu-list a {
        color: black;
    }

    .main-menu-list {
        border: 1px solid whitesmoke;
        color: #4a4a4a;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        margin-left: -15px;
        margin-right: -15px;
        padding: 10px;
        background-color: #999999;
        box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
    }

    .main-menu-list:hover {
        font-weight: 600;
        color: #FFFFFF;
        background-color: rgba(153, 153, 153, 0.6);
    }

    .main-menu-list-is-active {
        position: relative;
        background-color: rgba(153, 153, 153, 0.6);  /*rgba(0, 115, 170, 0.78);*/
        color: #4a4a4a;
        padding: 10px;
        margin-right: -15px;
    }

    .main-menu-list-label{
        margin: auto;
    }

    .menu-list a.is-active:after {
        position: absolute;
        content: "";
        right: 10px;
        display: inline-block;
        border-right: 4px solid whitesmoke;
        border-bottom: 4px solid whitesmoke;
        width: 10px;
        height: 10px;
        transform: rotate(-45deg);
        top: calc(50% - 5px);
    }

    .menu-list-item {
        margin-top: 15px;
        font-size: 17px;
        font-family: sans-serif;
        font-style: oblique;
    }

    .menu-label {
        margin-bottom: -40px;
        /*margin-left: 20px;*/
        color: #FFFFFF;
        background-color: gray;
        position: absolute;
        width: 100%;
        margin-left: -12px;
        text-align: center;
        padding: 0;
        height: 28px;
        text-align: -webkit-center;
        border: 0px solid;
        font-weight: 600;
        text-align: -webkit-center;
        margin-top: -6px;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.83);
    }

    ::-webkit-scrollbar {
        height: 2px;
        width: 8px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: rgba(206, 206, 206, 0);
    }

</style>
